import router from '../../../router/routes';
import axios from 'axios';

export default {
    namespaced: true,

    state: {
        siteId: 0,
        pageId: 0,
        pageSlug: '',
        pageRoute: '/api/page',
        pageName: '',
        pageSubtitle: '',
        pageCards: [],
        pageData: [],
        permissable: true,
    },

    mutations: {
        setPageId(state, value) {
            state.pageId = value;
        },

        setPageSlug(state, value) {
            state.pageSlug = value;
        },

        setPageData(state, value) {
            state.pageData = value;
        },

        setPageName(state, value) {
            state.pageName = value;
        },

        setPageSubtitle(state, value) {
            state.pageSubtitle = value;
        },

        setPageCards(state, value) {
            state.pageCards = value;
        },

        setPermissable(state, value) {
            state.permissable = value;
        }
    },

    actions: {
        getPageData({ commit, state }) {
            commit('overlay/toggle', true, { root: true });

            commit('setPageData', []);
            commit('setPageName', '');
            commit('setPageSlug', '');
            commit('setPageSubtitle', '');
            commit('setPageCards', []);
            commit('setPermissable', true);

            commit('setPageSlug', router.currentRoute.params.slug ? router.currentRoute.params.slug : 0);

            if (state.pageSlug) {
                axios.get(state.pageRoute + '/' + state.pageSlug)

                    // Success
                    .then((response) => {
                        const pageData = response.data.data.page;
                        commit('setPageData', pageData);
                        commit('setPageName', pageData.name);
                        commit('setPageSlug', pageData.slug);
                        commit('setPageSubtitle', pageData.subtitle);
                        commit('setPageCards', pageData.cards);
                        commit('setPermissable', true);
                        commit('overlay/toggle', false, { root: true });
                    })

                    // If there's an error here, the item doesn't exist.
                    .catch(() => {
                        // Show an error message.
                        commit('setPermissable', false);
                    });
            }
        },
    },
};
